import { Route } from 'react-router-dom'
import { lazy } from 'react'

const SignUp = lazy(() => import('./pages/SignUp'))
const FollowUpConsultation = lazy(() => import('./pages/FollowUpConsultation'))

const BeepRoutes = [
  <Route path="/beep" key="/beep" exact component={SignUp} />,
  <Route
    path="/beep/retorno"
    key="/beep/retorno"
    exact
    component={FollowUpConsultation}
  />,
]

export default BeepRoutes
